import * as React from 'react';
import classnames from 'classnames';
import { st, classes } from './Card.st.css';
import {
  CardProps,
  CardContainerProps,
  CardDefaultProps,
  CardDataHooks,
  CardDataKeys,
} from './types';

const Container: React.FunctionComponent<CardContainerProps> = (props) => {
  const { className, children, minWidth } = props;
  return (
    <div
      style={{ flexBasis: minWidth }}
      className={classnames(
        classes.container,
        classes.overrideStyleParams,
        className,
      )}
      data-hook={props['data-hook'] || CardDataHooks.CardContainer}
    >
      {children}
    </div>
  );
};

/** An implementation of Card for TPAs */
export class Card extends React.Component<CardProps> {
  static displayName = 'Card';
  static defaultProps: CardDefaultProps = {
    stacked: false,
  };

  static Container = Container;

  getDataAttributes() {
    const { stacked } = this.props;

    return {
      [CardDataKeys.Stacked]: stacked,
    };
  }

  render() {
    const { stacked, children, className } = this.props;

    return (
      <section
        data-hook={this.props['data-hook']}
        className={st(classes.root, { stacked }, className)}
        {...this.getDataAttributes()}
      >
        {children}
      </section>
    );
  }
}
